import type ModalConversationService from '../../../../modals/modal-conversation.service';
import {exists} from 'shared/utils/custom-utils';

// Usable only on text inputs and text areas!
export function specialSymbolsKeyboard(node: HTMLInputElement | HTMLTextAreaElement, modalConversationService: ModalConversationService | undefined) {
    const keyDownHandler = (event: KeyboardEvent) => {
        if (!event.ctrlKey || event.key !== 'F7' || !exists(modalConversationService)) {
            return;
        }

        modalConversationService.specialSymbolsKeyboard({inputRef: node});
    }

    node.addEventListener('keydown', keyDownHandler);

    return {
        destroy() {
            node.removeEventListener('keydown', keyDownHandler);
        }
    }
}

export function createSpecialSymbolsKeyboardAction(modalConversationService: ModalConversationService | undefined) {
    return (node: HTMLInputElement | HTMLTextAreaElement) => specialSymbolsKeyboard(node, modalConversationService);
}